import axios from 'axios/index'

// state
export const state = {
  isClanLoading: false,
  clan: null,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchClanStart(state) {
    state.isClanLoading = true
  },
  fetchClanSuccess(state, { clan, userId }) {
    state.isClanLoading = false
    state.clan = {
      ...clan,
      users: clan.users.map(user => ({
        ...user,
        isMe: user.id === userId,
      })).sort(({ score: scoreA }, { score: scoreB }) => {
        if (scoreB < scoreA) { return -1 }
        if (scoreB > scoreA) { return 1 }
        return 0
      }).sort(({ isMe }) => isMe ? -1 : 1),
    }
  },
  fetchClanFailed(state) {
    state.isClanLoading = false
  },
}
// actions
export const actions = {
  async fetchMyClan({ commit, rootGetters }) {
    try {
      commit('fetchClanStart')
      const clan = await axios.get('clan')
      commit('fetchClanSuccess', {
        clan,
        userId: rootGetters['auth/user'].id,
      })
    } catch (err) {
      commit('fetchClanFailed')
    }
    return false
  },
  async createClan({ commit }, { name }) {
    try {
      const clan = await axios.post('clan', {
        name,
      })
      return clan
    } catch (err) {
      console.log(err)
    }
  },
  async joinExistingClan({ commit }, { password }) {
    try {
      const clan = await axios.post('clan/join', {
        password,
      })
      return clan
    } catch (err) {
      console.log(err)
    }
  },
}
